export const MIN_SLIDER_VALUE = 20;
export const MAX_SLIDER_VALUE = 150;

export const SELECT_ITEMS = [
    { label: '1 комната', value: '1' },
    { label: '2 комнаты', value: '2' },
    { label: '3 комнаты', value: '3' },
    { label: '4 комнаты', value: '4' },
];

export const RANGE_ERROR = 'Указано недопустимое значение';
export const SELECT_ERROR = 'Поле обязательно для заполнения';
